import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../../lib/utils"

const labelVariants = cva(
  "flex items-center gap-2 leading-none font-black select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 tracking-tight",
  {
    variants: {
      size: {
        sm: "text-[11px] uppercase tracking-wide",
        md: "text-sm",
        lg: "text-base",
      },
    },
    defaultVariants: {
      size: "md",
    },
  }
)

export interface LabelProps
  extends React.ComponentProps<typeof LabelPrimitive.Root>,
    VariantProps<typeof labelVariants> {
  /**
   * If true, displays a required indicator (asterisk)
   */
  required?: boolean
}

function Label({ className, size, required, children, ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      data-size={size}
      className={cn(labelVariants({ size }), className)}
      {...props}
    >
      {children}
      {required && (
        <span
          data-slot="label-required"
          className="text-destructive"
          aria-hidden="true"
        >
          *
        </span>
      )}
    </LabelPrimitive.Root>
  )
}

Label.displayName = "Label"

export { Label }
